import React, { useState } from "react";
import EACheckbox from "../../shared/Checkbox/EACheckbox";
import EAButton from "../../shared/Buttons/EAButton";
import useFacility from "../../../../utils/hooks/useFacility";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import { useTranslation } from "react-i18next";
import { fillPrivacyPolicyUrl, newsletterConsentByFacility } from "./newsletterConsentByFacility";

interface IProps {
  onAllowMailingChange?: (value: boolean) => void;
  checked?: boolean;
}

// Zapis do newslettera (sendInvite) NIE jest wysyłany stąd — samo zaznaczenie
// checkboxa tylko ustawia wartość w formularzu (setValue("allowMailing", ...) w
// ConsentInputs). Realny request idzie z useFinalizeManager PO udanym
// saveReservation/acceptTransaction, a przed przekierowaniem do płatności.
// Na nowy mail byEmail wymaga już istniejącego konta (tworzy je rezerwacja);
// bez await przed redirectem request ginie przy unloadzie strony.
const NewsletterCheckbox: React.FC<IProps> = ({ onAllowMailingChange, checked: externalChecked }) => {
  const [localChecked, setLocalChecked] = useState(false);
  const isChecked = externalChecked !== undefined ? externalChecked : localChecked;
  const [openText, setOpenText] = useState(false);
  const { t } = useTranslation();
  const facilityIds = useFacility();
  const newsletterActive = useSelector((state: State) => state.config.configuration?.newsLetterActive);
  const privatePolicy = useSelector((state: State) => state.config.configuration?.regulaminList[0]?.file);
  const facilityConsent = newsletterConsentByFacility[facilityIds];

  const standardLabel = t(
    "Zaznaczając to pole, wyrażam zgodę na otrzymywanie newslettera drogą mailową. Rozumiem i akceptuję warunki <a target='_blank' href='{{privatePolicy}}'>polityki prywatności</a> dotyczące przetwarzania moich danych osobowych.",
    { privatePolicy }
  );

  const handleChange = (value: boolean) => {
    setLocalChecked(value);
    if (onAllowMailingChange) {
      onAllowMailingChange(value);
    }
  };

  if (!newsletterActive) return null;

  const label = facilityConsent?.labelHtml ? (
    <span
      dangerouslySetInnerHTML={{ __html: fillPrivacyPolicyUrl(facilityConsent.labelHtml, privatePolicy) }}
    />
  ) : facilityConsent?.label ? (
    <span>{t(facilityConsent.label)}</span>
  ) : (
    <span dangerouslySetInnerHTML={{ __html: standardLabel }} />
  );

  return (
    <div style={{ marginTop: "16px" }}>
      <div className="flex-start-center">
        <h5>{t("dolacz_do_newslettera")}</h5>
      </div>

      <EACheckbox name="newsletter" checked={isChecked} onChange={handleChange} label={label} />

      {facilityConsent?.details && (
        <>
          <EAButton
            title={openText ? t("gotowe_schowaj") : t("przeczytaj_calosc")}
            onClick={() => setOpenText((prev) => !prev)}
            variant="text"
            noMargins
            color={openText ? "secondary" : "primary"}
          />

          {openText && <p className="newsletter__description">{facilityConsent.details}</p>}
        </>
      )}
    </div>
  );
};

export default NewsletterCheckbox;
